import ng from 'angular';
import { AuthContextService, GetEntryPointService } from '@/services';
import { LinkListItem } from '../../links/link-list/link-list';
import './panel-support.scss';
import { SupportFormData } from '@/atomic-components';

type IframeToParentMessage =
    | { type: 'showContactForm' }
    | { type: 'resize'; height: number };

type ParentToIframeMessage =
    | { type: 'setLayout'; fontSize: string; bodyPaddingX: string };

export class MoleculePanelSupportController implements ng.IController {
    public static $inject: string[] = [
        'authContext',
        'getEntryPoint',
        '$translate',
        '$timeout',
        '$window',
        '$element',
        '$sce'
    ];

    public displayContent = false;
    public displaySupportModal: any = {
        contact: false,
        promise: false
    };
    public panelItemList: LinkListItem[];
    public skipAuthCheck = false; // for account activation netim -> hosting
    public supportFormDataOverwrite: SupportFormData;

    constructor(
        private authContext: AuthContextService,
        private getEntryPoint: GetEntryPointService,
        protected $translate: ng.translate.ITranslateService,
        private $timeout: ng.ITimeoutService,
        private $window: ng.IWindowService,
        private $element: ng.IAugmentedJQuery,
        private $sce: ng.ISCEService
    ) {}

    // They look unused but they are in the iframe coming from backend
    private _messageHandler: (event: MessageEvent) => void;
    private _resizeHandler: () => void;

    public $onInit() {
        this.displayContent = this.getEntryPoint.showSupportOptions;

        this._messageHandler = (event: MessageEvent) => {
            const iframe = this.$element[0].querySelector('iframe') as HTMLIFrameElement;
            if (!iframe || event.source !== iframe.contentWindow) return;

            const msg = event.data as IframeToParentMessage | undefined;
            if (!msg || typeof msg.type !== 'string') return;

            if (msg.type === 'showContactForm') {
                this.$timeout(() => this.showContactForm());
            } else if (msg.type === 'resize' && typeof msg.height === 'number') {
                iframe.style.height = msg.height + 'px';
            }
        };
        window.addEventListener('message', this._messageHandler);

        if (this.isNetcologneCustomer) {
            this._resizeHandler = () => this._sendLayout();
            window.addEventListener('resize', this._resizeHandler);
        }

        this.panelItemList = [
            {
                isGranted: true,
                onclickMethode: this.showSupportPromise,
                text: this.$translate.instant('TR_100119-c7dc72_TR')
            }, {
                isGranted: true,
                onclickMethode: this.showContactForm,
                text: this.$translate.instant('TR_100119-e49b56_TR')
            }
        ];
    }

    public $postLink() {
        if (!this.isNetcologneCustomer) return;
        const iframe = this.$element[0].querySelector('iframe') as HTMLIFrameElement;
        if (!iframe) return;

        // iframes can finish loading synchronously, so the 'load' event may
        // already have fired by the time $postLink runs. Check readyState first;
        // only fall back to the listener if loading is still in progress.
        if (iframe.contentDocument?.readyState === 'complete') {
            this._sendLayout();
        } else {
            iframe.addEventListener('load', () => this._sendLayout(), { once: true });
        }
    }

    public $onDestroy() {
        window.removeEventListener('message', this._messageHandler);
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
        }
    }

    public showSupportPromise = () => {
        this.displaySupportModal.promise = true;
    };

    public showContactForm = () => {
        this.displaySupportModal.contact = true;
    };

    public showOnlyOnResellerAccounts = () => {
        return this.skipAuthCheck ? true : +this.authContext.account.parentAccountId <= 1000;
    };

    // TODO: replace with a generic check (e.g. customSupportPanelUrl from
    // getEntryPoint) when a second brand needs its own support panel
    public get isNetcologneCustomer(): boolean {
        return this.getEntryPoint.isNetCologne;
    }

    public get supportBlock() {
        const html = this.authContext.accountOrganizationInformation.supportBlock;
        return this.$sce.trustAsHtml(html);
    }

    private _sendLayout() {
        const iframe = this.$element[0].querySelector('iframe') as HTMLIFrameElement;
        if (!iframe?.contentWindow) return;
        const width = this.$window.innerWidth;
        const fontSize = width >= 1200 ? '14px' : width >= 960 ? '13px' : '12px';
        const bodyPaddingX = width >= 640 ? '28px' : '21px';
        const msg: ParentToIframeMessage = { type: 'setLayout', fontSize, bodyPaddingX };
        iframe.contentWindow.postMessage(msg, '*');
    }
}

export class MoleculePanelSupportComponent implements ng.IComponentOptions {
    public bindings = {
        skipAuthCheck: '<?',
        supportFormDataOverwrite: '<?',
    };
    public controller =  MoleculePanelSupportController;
    public template = require('./panel-support.html');
}
